import React, { Component, Fragment } from 'react';

class works extends Component {
    state = {
        data: [
            {
                link: "https://hoproject.our-work.com.tw/2020/0427-uniwater/",
                img: "uniwater.png",
                name: "UNI water | 風格主張",
                content: "互動設計 / API串接 / 資料庫"
            },
            {
                link: "https://www.our-work.com.tw/demosite/2020/2020-pxmart/game.html",
                img: "px.png",
                name: "全聯 | 達人檢定烤",
                content: "互動設計 / API串接"
            },
            {
                link: "https://www.our-work.com.tw/demosite/2020/2020-thu-ai/",
                img: "ai.jpg",
                name: "東海大學 | 檢測你的AI指數",
                content: "互動設計 / API串接"
            },
            {
                link: "https://www.our-work.com.tw/demosite/2020/2020-cheerfood/",
                img: "cheerfood.png",
                name: "川見鱈蟹柳",
                content: "互動設計 / API串接 / 資料庫"
            },
            {
                link: "http://www.our-work.com.tw/demosite/2020/2020-IBM/",
                img: "ibm2.png",
                name: "IBM | 資安人員你有多崩潰",
                content: "互動設計 / API串接"
            },
            {
                link: "https://www.our-work.com.tw/demosite/2020/2020-JPMorgan/",
                img: "jp.png",
                name: "JP Morgan",
                content: "RWD 網站"
            },
            {
                link: "https://www.our-work.com.tw/demosite/2020/2020-RS/",
                img: "rs.png",
                name: "皇家禮炮",
                content: "RWD 網站"
            },
            {
                link: "http://our-work.com.tw/demosite/2019/2019_nutrilon_danone/",
                img: "nd.png",
                name: "諾優能 | 寶寶小情歌",
                content: "互動設計 / API串接"
            },
            {
                link: "https://ibmsystemsstorage.techorange.com/",
                img: "Mockup6.jpg",
                name: "IBM | 資料塑型中心",
                content: "互動設計 / API串接"
            },
            {
                link: "https://www.nutrilon-event.com/babygreetings/index.html",
                img: "Mockup7.jpg",
                name: "諾優能 | 寶寶晚輩圖",
                content: "互動設計 / 網站前端 / API串接"
            },
            {
                link: "https://www.enbw.com.tw/tw/index.aspx",
                img: "Mockup5.jpg",
                name: "安能亞太",
                content: "RWD / 官網維運"
            },
            {
                link: "https://www.amicolla.tw/2019Q2/",
                img: "Mockup3.jpg",
                name: "明治 | 閨蜜救援任務",
                content: "互動設計 / 網站前端 / API串接"
            },
            {
                link: "http://www.saeco.philips.com.tw/xelsis/",
                img: "Mockup4.jpg",
                name: "飛利浦 | SAECO咖啡機",
                content: "RWD 網站"
            },
            // {
            //     link: "https://www.jacobscreek.com.tw/",
            //     img: "Mockup2.jpg",
            //     name: "傑卡斯 | 酒食樂生活",
            //     content: "互動設計 / 網站前端 / API串接"
            // },
            {
                link: "https://www.dynacw.com.tw/product/dfheifamily/",
                img: "Mockup1.jpg",
                name: "華康黑體系列官網",
                content: "RWD 網站"
            },
            {
                link: "https://www.our-work.com.tw/demosite/2019/2019-TaiwanExcellence-eSports/",
                img: "Mockup8.jpg",
                name: "臺灣精品｜電競杯",
                content: "RWD 網站 / 官網維運"
            },
            {
                link: "https://www.volkswagentaiwan.com.tw/tiguanallspace/index.html",
                img: "Mockup.jpg",
                name: "The Tiguan AllSpace",
                content: "官網維運"
            },
            {
                link: "",
                img: "iphonex.jpg",
                name: "亞伯樂-慢藝哲學",
                content: "互動設計 / 網站前端"
            },
            {
                link: "",
                img: "iphonex1.jpg",
                name: "百齡罈-Bouse",
                content: "互動設計 / 網站前端"
            },
            {
                link: "https://museum.mnd.gov.tw/ArmedForcesMuseum",
                img: "軍史館.png",
                name: "國軍歷史文物館",
                content: "RWD 網站"
            },
            {
                link: "https://www.newtaipeiheritage.tw/",
                img: "文化資產.jpg",
                name: "新北市文化資產數位學習網",
                content: "RWD / UI 設計"
            },
            {
                link: "http://free.tycg.gov.tw/index.html",
                img: "桃園無障礙.jpg",
                name: "桃園無障礙宣導網站",
                content: "RWD / UI 設計"
            },
        ]
    }
    render() {
        const { data } = this.state;
        return (
            <Fragment>
                {data.map((item, idx) => 
                    <div key={idx} className="works__group">
                        <a className="img" href={item.link} style={{
                            backgroundImage: `url(images/${item.img})`
                        }}>
                            <span>
                                <i className={
                                    `fas ${item.link === "" ? "fa-times" : "fa-link"}`
                                }></i>
                            </span>
                        </a>
                        <h2 className="title">{item.name}</h2>
                        <p className="content">{item.content}</p>
                    </div>
                )}
            </Fragment>
        );
    }
}

export default works;